import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setRoadmapData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_roadmap } from "http/components/Roadmap";
import AddCategoryRoadmapData from "./components/AddCategory";
import AddSubCategoryRoadmapData from "./components/AddSubCategory";
import TableRoadmapData from "./components/Table";

export default function RoadmapData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const { roadmap } = useSelector((state) => ({
    roadmap: state.mngr.roadmap,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (roadmap) getData();
  }, [roadmap]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_roadmap();
    if (CheckApiStatus(response)) {
      setData(response.data);
    }
    dispatch(setRoadmapData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 item size={{ lg: 5, md: 6, sm: 6, xs: 12 }}>
          <MPaper
            label={"New Category"}
            content={<AddCategoryRoadmapData />}
            className="h-100"
          />
        </Grid2>
        {data && data.length !== 0 && (
          <Grid2 item size={{ lg: 5, md: 6, sm: 6, xs: 12 }}>
            <MPaper
              label={"New Sub-category"}
              content={<AddSubCategoryRoadmapData data={data} />}
              className="h-100"
            />
          </Grid2>
        )}
        <Grid2 item size={{ xs: 12 }}>
          <MPaper
            label={"Roadmaps list"}
            content={<TableRoadmapData data={data} />}
            defaultExpanded={true}
          />
        </Grid2>
      </Grid2>
    </>
  );
}
